import Vue from "vue";
import Vuex from "vuex";

import mutations from './mutations'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    test: "",
    baseUrl:"https://www.shanghaieye.cn",               //视频地址
    testData: 1,
    actionData: 0,
    review_id: "",
    metaInfo: {
      title: '',
      keywords: '',
      description: '',
      url:""
    },
    preview:"",
    showShareModel:false,
    webConfig: {
      liveShow: {
        id: undefined,
        code: "live_show",
        value: "0",
      },
      liveImage: {
        id: undefined,
        code: "live_image",
        value: "",
      },
      liveUrl: {
        id: undefined,
        code: "live_url",
        value: "",
      },
      liveTitle: {
        id: undefined,
        code: "live_title",
      }
    }
  },
  mutations,
  actions,
  getters
});
